import PortalIdParser from 'PortalIdParser';
export const listPageUrlFromId = listId => {
  return `/contacts/${PortalIdParser.get()}/objectLists/${listId}/filters`;
};
export const datasetPageUrlFromId = datasetId => {
  return `/reporting-datasets/${PortalIdParser.get()}/view/${datasetId}/preview`;
};